module.exports = __webpack_public_path__ + "static/media/my transactions icon (active).b8f89d1b.svg";